export const ApiUrl = 'https://www.auth.wbidmax.com/WBidCoreService/api/';

// export const ApiUrl = 'https://108.181.97.197/WBidCoreService/api/';
// https://108.181.97.197/WBidCoreService/api/BidData/GetMonthlyBidFiles
// export const ApiUrl = 'http://localhost:61541/api/';
// export const ApiUrl =
//   'https://www.auth.wbidmax.com/WBidCoreServiceTestDBQA/api/';

// https://service.crewbid.dev.swalife.com/itest/if-line-base-auction/bid-round/DAL2024111/bids
export class SWAApiUrlProvider {
public static get SWAapiUrl(): string {
        const env = localStorage.getItem('EnvMode');
        if (env === 'QaMode') {
            return 'https://service.east.0.crewbid.qa.swalife.com/itest/';
        } else if (env === 'DevMode') {
        return 'https://itest.service.east.0.crewbid.dev.swalife.com/';
        } else if( env === 'ProdMode'){
            return 'https://service.crewbid.swalife.com/golden/';
        }
    }
   
}

